<template>
	<div class="erji-content pp50">
		<div class="container">
			<div class="erji-title">
				<h1>{{title}}</h1>
				<h2>{{titleEn}}</h2>
			</div>
			<div class="erji-content-div">
				<div class="single_detail" v-html="body"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'single',
		data(){
			return{
				title:'',
				titleEn:'',
				body:''
			}
		},
		methods:{
			res_menuClass(e){
				this.axios.get('/api/menus/class?id=' + e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.title = ''
							this.titleEn = ''
							this.title = response.data.reslut.name;
							this.titleEn = response.data.reslut.sub_title;
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			res_single(e){
				this.axios.get('/api/single?category_id=' + e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.body = ''
							this.body = response.data.reslut.body.replace(
								/<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
								(match, path) => {
									return path.search("http") == -1
										? `<img src='${this.icoURL}/${path}' />`
										: match;
								}
							);
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			}
		},
		created(){
			// console.log('关于我们',this.$route.query.category_id)
			this.res_menuClass(this.$route.query.category_id)
			this.res_single(this.$route.query.category_id)
		},
		watch :{
			'$route' (to, from) {
					// 对路由变化作出响应...
					// console.log("single_to",to)
					// console.log("single_from",from)
					this.title = ''
					this.titleEn = ''
					this.body = ''
					this.res_menuClass(this.$route.query.category_id)
					this.res_single(this.$route.query.category_id)
					console.log('wwww')
			}
		},
	}
</script>

<style>
</style>